import React from 'react';
import './IFrame.less';

const IFrame = ({src}) => (
    <figure className="IFrame">
        <div className="IFrame__wrapper">
            <iframe
                width="100%"
                height="100%"
                src={src}
                frameBorder="0"
                allowFullScreen
            />
        </div>
    </figure>
);

export default IFrame;
